import { Link } from 'react-router-dom';
import { type Program } from '../lib/programs';

interface Props {
  program: Program;
}

const accentClass: Record<Program['accent'], string> = {
  sage: 'before:bg-[var(--color-sage)]',
  tan: 'before:bg-[var(--color-tan)]',
  cream: 'before:bg-[var(--color-ink-soft)]',
};

export function ProgramCard({ program }: Props) {
  return (
    <article
      className={`group relative flex h-full flex-col overflow-hidden rounded-[var(--radius-lg)] border border-[var(--color-border)] bg-[var(--color-surface)] p-7 shadow-[var(--shadow-card)] transition-shadow duration-200 hover:shadow-[0_4px_12px_rgba(31,34,30,0.06),0_18px_40px_rgba(31,34,30,0.10)] before:absolute before:left-0 before:top-0 before:h-full before:w-1 ${accentClass[program.accent]}`}
    >
      <p className="eyebrow">Program</p>
      <h3 className="mt-2 font-display text-[1.6rem] text-[var(--color-ink)]">
        {program.name}
      </h3>
      <p className="mt-1 text-[var(--color-sage-deep)]">
        {program.tagline}
      </p>
      <p className="mt-5 text-[var(--color-ink-soft)]">
        {program.shortDescription}
      </p>
      <div className="mt-6 rounded-md bg-[var(--color-cream)] p-4 text-sm text-[var(--color-ink-soft)]">
        <span className="font-semibold text-[var(--color-ink)]">Best for: </span>
        {program.bestFor}
      </div>
      <div className="mt-auto pt-6">
        <Link
          to={`/programs/${program.slug}`}
          className="inline-flex items-center gap-1 font-semibold no-underline"
        >
          Learn more
          <span aria-hidden className="transition-transform duration-200 group-hover:translate-x-1">
            →
          </span>
        </Link>
      </div>
    </article>
  );
}
